import { useEffect, useState } from 'react';
import { healthcareRatesGateway } from './index';
import { defaultTagsFor, primaryIndustryLabel, type CompanyIndustryProfile } from './types';

export interface CompanyIndustryState {
  /** The industry tags the pickers list first (suggestions only). Empty when the company has not chosen an industry or it cannot be read. */
  tags: string[];
  /** A short plain label for the primary industry ("Construction", "Hospice"), or null. */
  label: string | null;
  /** The tags a worker category or work type the company creates should carry by default (its primary industry's sector). */
  defaultTags: string[];
  isHealthcare: boolean;
  profile: CompanyIndustryProfile | null;
  loaded: boolean;
}

const EMPTY: CompanyIndustryState = { tags: [], label: null, defaultTags: [], isHealthcare: false, profile: null, loaded: false };

/**
 * The company industry profile (PayrollConfig, `workrates.read`). It only decides which defaults are suggested first: a person without that
 * permission, or a service that is down, simply gets every default listed, and the industry is never required to pick a worker category.
 */
export function useCompanyIndustry(): CompanyIndustryState {
  const [state, setState] = useState<CompanyIndustryState>(EMPTY);
  useEffect(() => {
    const controller = new AbortController();
    healthcareRatesGateway
      .getIndustryProfile(controller.signal)
      .then((profile) => {
        if (controller.signal.aborted) return;
        setState({ tags: profile.suggestionTags, label: primaryIndustryLabel(profile), defaultTags: defaultTagsFor(profile), isHealthcare: profile.isHealthcare, profile, loaded: true });
      })
      .catch(() => { if (!controller.signal.aborted) setState({ ...EMPTY, loaded: true }); });
    return () => controller.abort();
  }, []);
  return state;
}
